// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"representative_wrapper__vnBFc","name":"representative_name__U_XCh"};